import FilterDropdown from "components/filters/FilterDropdown";
import { useState } from "react";
import { ethers } from "ethers";
import clsx from "clsx";
import { shorten } from "util/util";

export default function AddressInputFilter({
  name,
  value,
  setValue,
}: {
  name: string;
  value: string;
  setValue: (val: string) => void;
}) {
  const [input, setInput] = useState(value);
  const [error, setError] = useState(false);
  const onClear = (close: () => void) => {
    close();
    setValue("");
  };
  const onSubmit = (close: () => void) => {
    let address = "";
    if (input !== "") {
      try {
        address = ethers.utils.getAddress(input);
      } catch {
        setError(true);
        return;
      }
    }
    close();
    setValue(address);
  };
  const displayName = value
    ? `${name}: ${shorten(value, 6, 4)}`
    : `${name} Address`;
  return (
    <FilterDropdown
      name={displayName}
      active={Boolean(value)}
      onSubmit={onSubmit}
      onClear={onClear}
    >
      <div>
        <label className="block text-sm text-gray-900">
          {name} Address
          <input
            className={clsx(
              "mt-2 block w-full rounded-md border border-gray-300 p-1 font-normal shadow-sm focus:border-succinct-black focus:ring-succinct-black sm:text-sm",
              error &&
                "border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500"
            )}
            value={input}
            onChange={(e) => {
              setError(false);
              setInput(e.target.value);
            }}
            aria-invalid={error}
          />
        </label>
      </div>
    </FilterDropdown>
  );
}
